import React from 'react';
import './styles.module.scss';
import { dualBarFlexParts } from '../../constants';

export default function StatThinBar({ home, away }) {
  const { homeFlex, awayFlex, isEmpty } = dualBarFlexParts(home, away);

  return (
    <div className="wcestadisticas-partido__thin-bar" aria-hidden>
      <div className="wcestadisticas-partido__thin-bar-inner">
        {isEmpty ? (
          <div className="wcestadisticas-partido__thin-bar-empty" />
        ) : (
          <>
            <div
              className="wcestadisticas-partido__thin-bar-home"
              style={{ flexGrow: homeFlex, flexShrink: 1, flexBasis: 0 }}
            />
            <div
              className="wcestadisticas-partido__thin-bar-away"
              style={{ flexGrow: awayFlex, flexShrink: 1, flexBasis: 0 }}
            />
          </>
        )}
      </div>
    </div>
  );
}
